import {CompanyGeneralInfoFormService} from "./company-general-info.form.service";
import {Product} from "../../../../store/state/order.state";
import {FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/state/app.state";
import {UmbrellaValidators} from "../../../../umbrella-common/validation/umbrella-validators";
import {distinctUntilChanged} from "rxjs/operators";
import {OrderActions} from "../../../../store/actions/order.actions";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {BaseFormControlHandler} from "./form-control.handler";
import {Injectable} from "@angular/core";

@Injectable()
export class EmployeeCountHandler extends BaseFormControlHandler {

	constructor(private fb: FormBuilder, private store: Store<AppState>) {
		super();
	}

	buildControls(form: FormGroup, product: Product) {
		const standardName = product.standard.name;
		const validators = [Validators.required, UmbrellaValidators.minInteger(1), Validators.max(CompanyGeneralInfoFormService.MAX_NUMBER_OF_EMPLOYEES), this.notLowerThanEmployeesWithinScope(form, standardName)];
		const control = this.fb.control(product.employees, validators);
		this.addSubscription(product.standard.name, control.valueChanges.pipe(distinctUntilChanged())
			.subscribe(employees => {
				if (this.canSaveEmployeesNumber(employees)) {
					this.store.dispatch(OrderActions.SET_EMPLOYEES_COUNT({standardName, employees}));
				}
			}));

		form.addControl('employeesCount' + product.standard.name, control);
	}

	protected fillProduct(formService: FormService, srcForm: string, product: Product): void {
		product.employees = formService.getValueFor('employeesCount', srcForm);
	}

	private canSaveEmployeesNumber(employees: any): boolean {
		return employees != null && Number.isInteger(employees) && employees > 0;
	}

	private notLowerThanEmployeesWithinScope(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const employeesWithinScopeControl = form.controls[`employeesWithinScope${formKey}`];

			if (employeesWithinScopeControl == null || employeesWithinScopeControl.value == null || control.value == null) {
				return null;
			}

			return control.value < employeesWithinScopeControl.value ?
				{employeeWithinScopeToLow: []} as ValidationErrors :
				null;
		};
	}
}
